import operator from 'operator'
import delegate from 'delegate'
import { bus } from './bus.js'
import { toApiUri } from './helpers.js'

let previousLocation = window.location.pathname
let loadingTimeout = null
let isPopState = false

const app = (window.GPLA_APP = operator('[data-operator-viewport]'))

// Set previous location on link click
delegate(
  document.body,
  'a[href]',
  'click',
  (e) => {
    previousLocation = window.location.pathname
  },
  true
)

// Update title on page load
updateTitle(document)

// Close existing popup on `before` navigate
app.on('before', (state) => {
  bus.emit('map:page', toApiUri(state.location))
})

app.on('navigate', (state) => {
  // Don't do anything when navigating to same route
  if (previousLocation === state.location) return

  // Add loading timeout after 250ms
  loadingTimeout = setTimeout(() => {
    document.documentElement.classList.add('loading')
  }, 250)
})

app.on('after', ({ previousDocument, location }) => {
  // Clear loading timeout
  clearTimeout(loadingTimeout)
  document.documentElement.classList.remove('loading')

  // Update title
  updateTitle(previousDocument)

  // Update route
  if (isPopState) {
    // When navigating back with browser back button, replace state
    window.history.replaceState(null, '', location)  
    isPopState = false
  } else {
    window.history.pushState(null, '', location)
  }

  // Update opengraph
  let opengraphTags = [
    ...previousDocument.querySelectorAll('[property^="og:"]'),
  ]
  opengraphTags.forEach((tag) => {
    let existingOpengraphTag = document.querySelector(
      `[property="${tag.getAttribute('property')}"`
    )
    if (existingOpengraphTag) existingOpengraphTag.content = tag.content
  })

  // Update theme color
  let meta = document.querySelector('meta[name="theme-color"]')
  if (meta) {
    meta.content = previousDocument.querySelector('[name="theme-color"]').content
  }

  // Update classes
  updateClasses(previousDocument)

  // Update areas
  updateAreas(previousDocument)

  // Reset scroll position
  window.scrollTo(0, 0)

  // Refresh Instagram Embeds
  window?.instgrm?.Embeds?.process()
})

window.onpopstate = function () {
  isPopState = true
}

/**
 * Add a `data-operator-classes` attribute to all elements
 * outside the operator viewport that should have their
 * classList updated on navigate.
 */
function updateClasses(previousDocument) {
  const oldElements = [
    ...previousDocument.querySelectorAll('[data-operator-classes]'),
  ]
  const newElements = [...document.querySelectorAll('[data-operator-classes]')]
  newElements.forEach((newElement, i) => {
    let oldElement = oldElements[i]
    let oldClasses = [...oldElement.classList]
    let newClasses = [...newElement.classList]
    let classesToRemove = newClasses.filter((x) => !oldClasses.includes(x))
    let classesToAdd = oldClasses.filter((x) => !newClasses.includes(x))
    newElement.classList.remove(...classesToRemove)
    newElement.classList.add(...classesToAdd)
  })
}

/**
 * Add a `data-operator-area` attribute to all elements
 * outside the operator viewport that should have their
 * contents updated on navigate.
 */
function updateAreas(previousDocument) {
  const newElements = [
    ...previousDocument.querySelectorAll('[data-operator-area]'),
  ]
  const currentElements = [...document.querySelectorAll('[data-operator-area]')]
  currentElements.forEach((currentElement, i) => {
    let newElement = newElements[i]
    if (!newElement) return
    currentElement.replaceWith(newElement)
  })
}

/**
 * Update the title of the page
 */
function updateTitle(previousDocument) {
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
    if (previousDocument.title.indexOf('|') === -1) {
      document.title = ''
    } else {
      document.title = previousDocument.title.replace(/^.*?\|\s*/, '')
    }
  } else {
    document.title = previousDocument.title
  }
}
